'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _camelCase2 = require('lodash/camelCase');

var _camelCase3 = _interopRequireDefault(_camelCase2);

var _createHumps = require('./createHumps');

var _createHumps2 = _interopRequireDefault(_createHumps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Only export the one default. Be friendly to CommonJS.
exports.default = (0, _createHumps2.default)(_camelCase3.default);
module.exports = exports['default'];